import { render } from "./SpaceBuilder.vue?vue&type=template&id=0b82794e"
import script from "./SpaceBuilder.vue?vue&type=script&lang=js"
export * from "./SpaceBuilder.vue?vue&type=script&lang=js"

import "./SpaceBuilder.vue?vue&type=style&index=0&id=0b82794e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/space/SpaceBuilder.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0b82794e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0b82794e', __exports__)) {
    api.reload('0b82794e', __exports__)
  }
  
  module.hot.accept("./SpaceBuilder.vue?vue&type=template&id=0b82794e", () => {
    api.rerender('0b82794e', render)
  })

}


export default __exports__